var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3419 14.4902L18.3419 12.8302C18.1319 12.4602 17.9419 11.7602 17.9419 11.3502V8.82016C17.9407 7.70419 17.6236 6.61137 17.0272 5.66813C16.4308 4.72489 15.5795 3.96978 14.5719 3.49016C14.3147 3.0335 13.9396 2.6543 13.4857 2.3922C13.0319 2.13009 12.516 1.99469 11.9919 2.00016C10.9019 2.00016 9.9219 2.59016 9.4019 3.52016C7.4519 4.49016 6.1019 6.50016 6.1019 8.82016V11.3502C6.1019 11.7602 5.9119 12.4602 5.7019 12.8202L4.6919 14.4902C4.2919 15.1602 4.2019 15.9002 4.4519 16.5802C4.6919 17.2502 5.2619 17.7702 6.0019 18.0202C7.9419 18.6802 9.9819 19.0002 12.0219 19.0002C14.0619 19.0002 16.1019 18.6802 18.0419 18.0302C18.7419 17.8002 19.2819 17.2702 19.5419 16.5802C19.8019 15.8902 19.7319 15.1302 19.3419 14.4902ZM14.8319 20.0102C14.6216 20.5923 14.2372 21.0956 13.7309 21.4516C13.2245 21.8077 12.6209 21.9992 12.0019 22.0002C11.2119 22.0002 10.4319 21.6802 9.8819 21.1102C9.5619 20.8102 9.3219 20.4102 9.1819 20.0002C9.3119 20.0202 9.4419 20.0302 9.5819 20.0502C9.8119 20.0802 10.0519 20.1102 10.2919 20.1302C10.8619 20.1802 11.4419 20.2102 12.0219 20.2102C12.5919 20.2102 13.1619 20.1802 13.7219 20.1302C13.9319 20.1102 14.1419 20.1002 14.3419 20.0702L14.8319 20.0102Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationicon);
export default __webpack_public_path__ + "static/media/notification icon.0ce9f6c2.svg";
export { ForwardRef as ReactComponent };